import {
  IconSearch,
  IconUser,
  IconUsers,
  IconCalendarEvent,
  IconCalendarPlus,
  IconUserPlus,
  IconTestPipe,
  IconReportMedical,
  IconTestPipeOff,
  IconVaccine,
  IconMedicineSyrup,
  IconBuildingStore,
  IconTemplate,
  IconTable,
} from "@tabler/icons";

const icons = {
  IconSearch,
  IconUser,
  IconUsers,
  IconCalendarEvent,
  IconCalendarPlus,
  IconUserPlus,
  IconTestPipe,
  IconTestPipeOff,
  IconVaccine,
  IconReportMedical,
  IconMedicineSyrup,
  IconBuildingStore,
  IconTemplate,
  IconTable,
};

const clinic = {
  id: "clinic",
  title: "Medical Operations",
  type: "group",
  children: [
    {
      id: "patients",
      title: "Patients",
      type: "item",
      url: "/patients",
      icon: icons.IconUser,
      breadcrumbs: "true",
    },
    {
      id: "patient-groups",
      title: "Patient Groups",
      type: "item",
      url: "/patient-groups",
      icon: icons.IconUsers,
      breadcrumbs: "true",
    },
    {
      id: "appointments",
      title: "Appointments",
      type: "item",
      url: "/appointments",
      icon: icons.IconCalendarEvent,
      breadcrumbs: "true",
    },
    {
      id: "tests",
      title: "Tests",
      type: "item",
      url: "/tests",
      icon: icons.IconTestPipe,
      breadcrumbs: "true",
    },
    {
      id: "medications",
      title: "Medications",
      type: "item",
      url: "/medications",
      icon: icons.IconVaccine,
      breadcrumbs: "true",
    },
    {
      id: "equipment",
      title: "Equipment",
      type: "item",
      url: "/equipment",
      icon: icons.IconTestPipeOff,
      breadcrumbs: "true",
    },
    {
      id: "diagnoses",
      title: "Diagnoses",
      type: "item",
      url: "/diagnoses",
      icon: icons.IconReportMedical,
      breadcrumbs: "true",
    },
    {
      id: "inventory-management",
      title: "Inventory Management",
      type: "collapse",
      icon: icons.IconBuildingStore,
      breadcrumbs: "true",
      children: [
        {
          id: "Inventory Templates",
          title: "Inventory Templates",
          type: "item",
          icon: icons.IconTemplate,
          breadcrumbs: "true",
          url: "/inventory-templates",
        },
        {
          id: "inventory",
          title: "Inventory",
          type: "item",
          icon: icons.IconTable,
          breadcrumbs: "true",
          url: "/inventories",
        },        
      ],
    },
  ],
};

export default clinic;
